<!-- Start Breadcrumb -->
<app-breadcrumb>
    <li class="breadcrumb-item"><a href="#"><i class="fa fa-home"></i> Home</a></li>
    <li class="breadcrumb-item"><a href="#">Faqet</a></li>
    <li class="breadcrumb-item active" aria-current="page">Intepretimet</li>
</app-breadcrumb>
<!-- End Breadcrumb -->

<!-- Start Section -->
<section class="section pt-40">
    <div class="container">
        <div class="row">
            <div class="col-lg-6 offset-lg-3">
                <h2 class="section__heading section__heading-center" *ngIf="langVariable == 'SQ'">Interpretimet</h2>
                <h2 class="section__heading section__heading-center" *ngIf="langVariable == 'EN'">Interpretation</h2>
                <h2 class="section__heading section__heading-center" *ngIf="langVariable == 'SR'">Tumačenje</h2>
            </div>
            <div *ngIf="langVariable == 'SQ'">
                <h5>Konform nenit 87, paragrafit 2, nën paragrafit 2.8 të Ligjit Nr. 04/L-042 për Prokurimin Publik, i ndryshuar dhe plotësuar me Ligjin Nr. 04/L-237, Ligjin Nr. 05/L-068 dhe Ligjin Nr. 05/L-092, Departamenti i Rregullave pranë KRPP-së ka vlerësuar shqyrtuar pyetjet e adresuara në "rregullat.krpp@rks-gov.net" dhe për pyetjet e shpeshta ka përgatitë dhe publikuar interpretimet: 
                </h5>
            </div>
            <div *ngIf="langVariable == 'EN'">
                <h5>Konform nenit 87, paragrafit 2, nën paragrafit 2.8 të Ligjit Nr. 04/L-042 për Prokurimin Publik, i ndryshuar dhe plotësuar me Ligjin Nr. 04/L-237, Ligjin Nr. 05/L-068 dhe Ligjin Nr. 05/L-092, Departamenti i Rregullave pranë KRPP-së ka vlerësuar shqyrtuar pyetjet e adresuara në "rregullat.krpp@rks-gov.net" dhe për pyetjet e shpeshta ka përgatitë dhe publikuar interpretimet: 
                </h5>
            </div>
            <div *ngIf="langVariable == 'SR'">
                <h5>Konform nenit 87, paragrafit 2, nën paragrafit 2.8 të Ligjit Nr. 04/L-042 për Prokurimin Publik, i ndryshuar dhe plotësuar me Ligjin Nr. 04/L-237, Ligjin Nr. 05/L-068 dhe Ligjin Nr. 05/L-092, Departamenti i Rregullave pranë KRPP-së ka vlerësuar shqyrtuar pyetjet e adresuara në "rregullat.krpp@rks-gov.net" dhe për pyetjet e shpeshta ka përgatitë dhe publikuar interpretimet: 
                </h5>
            </div>


        </div>
        <div class="row">
            <div class="col-lg-12">
                <div class="accordion" id="faq">
                    <!-- Start FAQ -->
                    <div *ngFor="let item of interpretimet; let index = index " class="accordion__group">
                        <!--<div *ngIf="item.id == 6"></div>-->
                        <button *ngIf="langVariable == 'SQ'" class="accordion__link collapsed" type="button" data-bs-toggle="collapse" [attr.data-bs-target]="'#collapse' + index" aria-expanded="true" [attr.aria-controls]="'collapse' + index">
                            {{item.attributes.Title}}
                        </button>
                        <button *ngIf="langVariable == 'EN'" class="accordion__link collapsed" type="button" data-bs-toggle="collapse" [attr.data-bs-target]="'#collapse' + index" aria-expanded="true" [attr.aria-controls]="'collapse' + index">
                            {{item.attributes.Title_EN}}
                        </button>
                        <button *ngIf="langVariable == 'SR'" class="accordion__link collapsed" type="button" data-bs-toggle="collapse" [attr.data-bs-target]="'#collapse' + index" aria-expanded="true" [attr.aria-controls]="'collapse' + index">
                            {{item.attributes.Title_SRB}}
                        </button>
                        <div [id]="'collapse' + index" class="collapse accordion__collapse" aria-labelledby="headingOne" data-parent="#faq">
                            <div *ngIf="langVariable == 'SQ'" class="card-body" [innerHTML]="item.attributes.Pershkrimi | sanitizeHtml"></div>
                            
                            <div *ngIf="langVariable == 'EN'" class="card-body" [innerHTML]="item.attributes.Pershkrimi_EN | sanitizeHtml"></div>
                            
                            <div *ngIf="langVariable == 'SR'" class="card-body" [innerHTML]="item.attributes.Pershkrimi_SRB | sanitizeHtml"></div>
                        </div>
                    </div>
                    <!-- End FAQ -->
                </div>
            </div>
        </div>
    </div>
</section>
<!-- End Section -->

<!-- Start Section -->
<call-to-action
    text="Ndërlidhja me e-prokurimin"
    link="contact"
></call-to-action>
<!-- End Section -->
